<!--尾部-->
<template>
  <div class="container">
    <div class="links">
      <div class="left-content">
        <div>
          <p style="font-size: 16px;font-weight: bold">友情链接:</p>
          <p style="margin-top:15px">
            <span
              class="link-friend pointer"
              v-for="(newsLink, index) in newsLinkList"
              :key="index"
              @click="toNewLink(newsLink.url)"
            >
            {{newsLink.name}}
            </span>
          </p>
        </div>
      </div>
      <el-divider class='divider'></el-divider>
      <div class="content-detail">
        <div class="content_left">
          <p>
            <span>版权所有：</span>
            <span>上海市嘉定区公共租赁住房运营有限公司</span>
          </p>
          <p>
            <span>技术支持：</span>
            <span>江苏瀚远科技股份有限公司</span>
          </p>
          <p>
            <span>备案号：</span>
            <span>
              <a style="color:#CCCCCC;text-decoration:none" href="https://beian.miit.gov.cn/" target="_blank">
                沪ICP备18002644号-1
              </a>
            </span>
          </p>
          <!-- <p style="display:none">
            <img src="../../assets/imgs/beian.png" alt />
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014599"
              style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
            >
              <img src style="float:left;" />
              <p
                style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#666;"
              >
                沪公网安备 31011502014599号
              </p>
            </a>
          </p> -->
        </div>
        <div class="content_right">
          <div class=content_contact>
            <p>
              <span>电话：</span>
              <span>021-69987999</span>
            </p>
            <p>
              <span>地址：</span>
              <span>上海市嘉定区平城路955弄3号</span>
            </p>
            <p>
              <span>邮箱：</span>
              <span>jiadinggzf@126.com</span>
            </p>
          </div>
          <div class="content_ico">
            <img src="../../assets/imgs/code_ico1.jpg" width="63" height="62" alt="上海嘉定区公租房服务号" />
          </div>
        </div>
        
      </div>
    </div>
    <!-- <div class="servers">
      <a
        href="https://v3.faqrobot.org/robot/chat1.html?jid=24594&sysNum=159280685263325377"
        target="blank"
      >
        <img src="../../assets/imgs/servers.png" style="border:none;" />
      </a>
    </div> -->
  </div>
</template>
<script>
import { get } from "@/api/common/index";
export default {
  data() {
    return {
      newsLinkList: [
        { name: "上海嘉定", url: "http://www.jiading.gov.cn/" },
        { name: "嘉定新城", url: "http://www.jdxc.net/" },
        { name: "上海住房公积金", url: "http://www.shgjj.com/" },
        { name: "上海长宁公共租赁", url: "http://www.shcngz.com/" },
        { name: "上海徐汇惠众公租房", url: "http://www.shxhgzf.com/hj/index.html" },
        { name: "上海国际人才网", url: "http://www.sh-italent.com/" },
      ],
    };
  },
  methods: {
    getNewsLinks() {
      get("/api/public/get_news_link_list").then((res) => {
        this.newsLinkList = res.data;
      });
    },
    toNewLink(url) {
      window.open(url, "_blank");
    },
  },
  mounted() {
    // 测试时，先去掉
    //this.getNewsLinks()
  },
};
</script>
<style scoped>

.container {
  margin: 0 auto 0 auto;
  width: 100%;
  background-color:#333333;
}

.links {
  width: 1166px;
  margin: 0 auto;
  padding: 30px 0 16px;
  color:white;
  font-size: 14px;
  line-height: 24px;
}

.left-content {
  text-align: left;
  display: flex;
  justify-content: space-between;
}

.content-detail {
  display: flex;
  justify-content: space-between;
}

.content_left p {
  margin-right: 20px;
  text-align: left;
  color: #CCCCCC;
}

.content_right{
  justify-content: space-between;
  display: flex;
}
.content_contact{
  margin-right: 30px;
}
.content_contact p{
  text-align: left;
  color: #CCCCCC;
}
.content_ico {
  justify-content: space-between;
  display: flex;
  text-align: left;
  margin:0 30px;
  width: 63px;
  height: 62px;
  background-color:white;
}

.servers {
  position: fixed;
  float: right;
  z-index: 1000;
  right: 0px;
  bottom: 120px;
  display: none;
}
.servers img {
  width: 35px;
  height: 113px;
}

.link-friend{
  line-height: 36px;
  padding-right:15px;
  border-right: 1px solid #c8c8c8;
  margin-right: 15px;
  color: #CCCCCC;
}

.divider{
  background-color:#666;
}
</style>
